import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeartIcon, SendIcon, UserIcon, ChevronDownIcon } from 'lucide-react';
interface Comment {
  id: string;
  name: string;
  text: string;
  likes: number;
  likedByUser: boolean;
  timestamp: number;
}
const DAY = 24 * 60 * 60 * 1000;
const INITIAL_COMMENTS: Comment[] = [{
  id: 's-1',
  name: 'Sandra, 38',
  text: 'Ich habe jahrelang schlecht geschlafen und dachte, das gehört einfach dazu. Seit ich mein Kissen gewechselt habe, wache ich zum ersten Mal ohne Nackenschmerzen auf. Hätte ich das mal früher gewusst.',
  likes: 24,
  likedByUser: false,
  timestamp: Date.now() - 1 * DAY
}, {
  id: 's-2',
  name: 'Maria, 45',
  text: 'Als Krankenschwester im Schichtdienst ist erholsamer Schlaf für mich überlebenswichtig. Seit ich auf ein ergonomisches Kissen umgestiegen bin, schlafe ich deutlich tiefer – selbst tagsüber nach der Nachtschicht.',
  likes: 19,
  likedByUser: false,
  timestamp: Date.now() - 2 * DAY
}, {
  id: 's-3',
  name: 'Laura, 33',
  text: 'Meine Freundin hat mir den Artikel geschickt und ich habe mich sofort wiedererkannt. Zwei Kinder, Vollzeitjob, und abends bin ich so erschöpft, dass ich trotzdem nicht einschlafen kann. Das richtige Kissen hat tatsächlich einen Unterschied gemacht.',
  likes: 17,
  likedByUser: false,
  timestamp: Date.now() - 2 * DAY
}, {
  id: 's-4',
  name: 'Kathrin, 29',
  text: 'Ich war skeptisch, ob ein Kissen wirklich so viel ändern kann. Nach zwei Wochen muss ich sagen: Ja, absolut. Mein Nacken fühlt sich morgens endlich entspannt an.',
  likes: 15,
  likedByUser: false,
  timestamp: Date.now() - 3 * DAY
}, {
  id: 's-5',
  name: 'Petra, 52',
  text: 'Seit den Wechseljahren schlafe ich furchtbar. Hitzewallungen, Unruhe, ständiges Aufwachen. Ein besseres Kissen hat zwar nicht alles gelöst, aber die Nackenschmerzen sind weg – und das allein ist Gold wert.',
  likes: 22,
  likedByUser: false,
  timestamp: Date.now() - 3 * DAY
}, {
  id: 's-6',
  name: 'Nina, 27',
  text: 'Home Office hat meinen Schlaf komplett ruiniert. Seit ich bewusster auf meine Schlafposition achte und das Kissen gewechselt habe, schlafe ich wieder durch. Danke für den Artikel!',
  likes: 11,
  likedByUser: false,
  timestamp: Date.now() - 4 * DAY
}, {
  id: 's-7',
  name: 'Claudia, 41',
  text: 'Mein Mann hat mich ausgelacht, als ich 80€ für ein Kissen ausgegeben habe. Jetzt will er auch eins. 😄',
  likes: 31,
  likedByUser: false,
  timestamp: Date.now() - 4 * DAY
}, {
  id: 's-8',
  name: 'Johanna, 36',
  text: 'Ich bin Lehrerin und stehe jeden Morgen um 5:30 auf. Früher bin ich mit Kopfschmerzen aufgewacht, fast jeden Tag. Seit dem neuen Kissen ist das vorbei. Klingt übertrieben, ist aber so.',
  likes: 14,
  likedByUser: false,
  timestamp: Date.now() - 5 * DAY
}, {
  id: 's-9',
  name: 'Stefanie, 44',
  text: 'Der Artikel trifft es auf den Punkt. Wir Frauen funktionieren einfach weiter, auch wenn wir total erschöpft sind. Schlaf wird immer als Erstes geopfert.',
  likes: 26,
  likedByUser: false,
  timestamp: Date.now() - 5 * DAY
}, {
  id: 's-10',
  name: 'Melanie, 31',
  text: 'Habe den Artikel meiner Mutter geschickt. Sie schläft seit 20 Jahren auf demselben Kissen und klagt jeden Morgen über Schmerzen. Vielleicht überzeugt sie das endlich.',
  likes: 9,
  likedByUser: false,
  timestamp: Date.now() - 6 * DAY
}, {
  id: 's-11',
  name: 'Birgit, 58',
  text: 'Mit 58 dachte ich, schlechter Schlaf gehört zum Älterwerden. Falsch gedacht. Ein gutes Kissen und eine kühlere Schlaftemperatur haben bei mir Wunder gewirkt.',
  likes: 18,
  likedByUser: false,
  timestamp: Date.now() - 7 * DAY
}, {
  id: 's-12',
  name: 'Tanja, 35',
  text: 'Ich stille noch nachts und bin sowieso ständig müde. Aber seit dem Kissenwechsel schlafe ich in den kurzen Phasen, die ich habe, viel tiefer. Das macht einen riesigen Unterschied.',
  likes: 13,
  likedByUser: false,
  timestamp: Date.now() - 7 * DAY
}, {
  id: 's-13',
  name: 'Anja, 40',
  text: 'Endlich spricht mal jemand das Thema an. Schlafmangel bei Frauen wird so normalisiert – dabei ist es ein echtes Gesundheitsproblem.',
  likes: 29,
  likedByUser: false,
  timestamp: Date.now() - 8 * DAY
}, {
  id: 's-14',
  name: 'Heike, 49',
  text: 'Ich habe drei verschiedene ergonomische Kissen ausprobiert, bis ich das richtige gefunden habe. Nicht jedes passt zu jedem – aber wenn es passt, merkt man es sofort.',
  likes: 7,
  likedByUser: false,
  timestamp: Date.now() - 9 * DAY
}, {
  id: 's-15',
  name: 'Franziska, 26',
  text: 'Bin über Instagram auf den Artikel gestoßen. Hätte nicht gedacht, dass mein Kissen schuld an meinen Verspannungen sein könnte. Bestelle mir jetzt ein neues!',
  likes: 10,
  likedByUser: false,
  timestamp: Date.now() - 9 * DAY
}, {
  id: 's-16',
  name: 'Susanne, 53',
  text: 'Meine Physiotherapeutin hat mir schon vor Jahren gesagt, ich soll mein Kissen wechseln. Hab ich ignoriert. Jetzt bereue ich es. Besser spät als nie.',
  likes: 16,
  likedByUser: false,
  timestamp: Date.now() - 10 * DAY
}, {
  id: 's-17',
  name: 'Lisa, 30',
  text: 'Ich schlafe auf der Seite und hatte immer Schulterprobleme. Mit einem Kissen, das für Seitenschläferinnen gemacht ist, ist das endlich besser geworden.',
  likes: 12,
  likedByUser: false,
  timestamp: Date.now() - 11 * DAY
}, {
  id: 's-18',
  name: 'Monika, 61',
  text: 'Toller Artikel. Ich habe ihn meiner Tochter weitergeleitet – sie ist Ärztin und schläft trotzdem nur 5 Stunden pro Nacht. Das kann nicht gesund sein.',
  likes: 8,
  likedByUser: false,
  timestamp: Date.now() - 12 * DAY
}, {
  id: 's-19',
  name: 'Daniela, 37',
  text: 'Seit ich Mutter bin, kenne ich keinen erholsamen Schlaf mehr. Der Tipp mit der Schlaftemperatur hat bei mir tatsächlich geholfen – 18 Grad und Fenster auf.',
  likes: 14,
  likedByUser: false,
  timestamp: Date.now() - 12 * DAY
}, {
  id: 's-20',
  name: 'Christine, 46',
  text: 'Ich arbeite im Großraumbüro und komme abends total überreizt nach Hause. Guter Schlaf ist für mich die einzige Möglichkeit, mich zu regenerieren. Danke für die Tipps!',
  likes: 6,
  likedByUser: false,
  timestamp: Date.now() - 13 * DAY
}, {
  id: 's-21',
  name: 'Sabine, 55',
  text: 'Mein Orthopäde hat mir ein ergonomisches Kissen empfohlen. Ich war überrascht, wie schnell sich mein Schlaf verbessert hat. Schon nach der ersten Nacht weniger Nackenschmerzen.',
  likes: 20,
  likedByUser: false,
  timestamp: Date.now() - 14 * DAY
}, {
  id: 's-22',
  name: 'Julia, 28',
  text: 'Ich dachte immer, ich bin einfach kein guter Schläfer. Turns out, mein Kissen war das Problem. Wer hätte das gedacht? 😅',
  likes: 15,
  likedByUser: false,
  timestamp: Date.now() - 15 * DAY
}, {
  id: 's-23',
  name: 'Renate, 63',
  text: 'In meinem Alter schläft man sowieso weniger, aber die Qualität zählt umso mehr. Ein gutes Kissen ist eine Investition in die Gesundheit.',
  likes: 11,
  likedByUser: false,
  timestamp: Date.now() - 16 * DAY
}, {
  id: 's-24',
  name: 'Kerstin, 42',
  text: 'Drei Kinder, Teilzeitjob, Haushalt. Ich schlafe vielleicht 6 Stunden – die müssen dann aber auch wirklich zählen. Seit dem neuen Kissen tun sie das endlich.',
  likes: 23,
  likedByUser: false,
  timestamp: Date.now() - 17 * DAY
}, {
  id: 's-25',
  name: 'Andrea, 39',
  text: 'Hab den Artikel in unserer Mütter-WhatsApp-Gruppe geteilt. Alle haben sich wiedererkannt. Traurig, aber wahr.',
  likes: 18,
  likedByUser: false,
  timestamp: Date.now() - 18 * DAY
}, {
  id: 's-26',
  name: 'Martina, 50',
  text: 'Ich habe jahrelang mit Migräne gekämpft. Seit ich mein Kissen und meine Schlafposition geändert habe, sind die Anfälle deutlich seltener geworden.',
  likes: 27,
  likedByUser: false,
  timestamp: Date.now() - 19 * DAY
}, {
  id: 's-27',
  name: 'Simone, 34',
  text: 'Als Selbstständige arbeite ich oft bis spät abends. Der Tipp mit weniger Bildschirmzeit vor dem Schlafen hat bei mir wirklich geholfen.',
  likes: 9,
  likedByUser: false,
  timestamp: Date.now() - 20 * DAY
}, {
  id: 's-28',
  name: 'Elke, 57',
  text: 'Meine Enkelin hat mir diesen Artikel gezeigt. Ich bin beeindruckt, wie gut das Thema hier erklärt wird. Verständlich und ohne Fachchinesisch.',
  likes: 13,
  likedByUser: false,
  timestamp: Date.now() - 21 * DAY
}, {
  id: 's-29',
  name: 'Vanessa, 25',
  text: 'Ich bin Studentin und schlafe auf einer billigen Matratze mit einem noch billigeren Kissen. Nach diesem Artikel spare ich jetzt auf ein gutes Kissen. Prioritäten!',
  likes: 16,
  likedByUser: false,
  timestamp: Date.now() - 22 * DAY
}, {
  id: 's-30',
  name: 'Gabriele, 48',
  text: 'Seit der Pandemie schlafe ich schlechter. Stress, Sorgen, zu viel Bildschirmzeit. Die Tipps hier sind einfach und umsetzbar – genau das braucht man.',
  likes: 10,
  likedByUser: false,
  timestamp: Date.now() - 23 * DAY
}, {
  id: 's-31',
  name: 'Ines, 43',
  text: 'Mein Mann schnarcht und ich liege wach. Zumindest kann ich jetzt dafür sorgen, dass die wenigen Stunden Schlaf, die ich bekomme, erholsam sind.',
  likes: 21,
  likedByUser: false,
  timestamp: Date.now() - 24 * DAY
}, {
  id: 's-32',
  name: 'Doris, 59',
  text: 'Ich habe das ergonomische Kissen meiner Schwester ausprobiert, als ich bei ihr übernachtet habe. Am nächsten Morgen habe ich sofort eins bestellt.',
  likes: 14,
  likedByUser: false,
  timestamp: Date.now() - 25 * DAY
}, {
  id: 's-33',
  name: 'Lena, 32',
  text: 'Schwanger und Schlafprobleme – eine tolle Kombination. 😩 Das Kissen hilft zumindest ein bisschen, den Nacken zu entlasten.',
  likes: 8,
  likedByUser: false,
  timestamp: Date.now() - 26 * DAY
}, {
  id: 's-34',
  name: 'Beate, 54',
  text: 'Ich habe den festen Schlafrhythmus-Tipp umgesetzt. Jeden Tag um 22:30 ins Bett, um 6:00 aufstehen. Nach drei Wochen fühle ich mich wie ein neuer Mensch.',
  likes: 19,
  likedByUser: false,
  timestamp: Date.now() - 27 * DAY
}, {
  id: 's-35',
  name: 'Hannah, 23',
  text: 'Bin erst 23 und schlafe jetzt schon schlecht. Dieser Artikel hat mir die Augen geöffnet – es liegt nicht am Alter, sondern an den Gewohnheiten.',
  likes: 12,
  likedByUser: false,
  timestamp: Date.now() - 28 * DAY
}, {
  id: 's-36',
  name: 'Ursula, 65',
  text: 'Seit ich in Rente bin, hätte ich endlich Zeit zum Schlafen – aber es klappt trotzdem nicht. Die Tipps hier probiere ich jetzt alle aus.',
  likes: 7,
  likedByUser: false,
  timestamp: Date.now() - 30 * DAY
}, {
  id: 's-37',
  name: 'Sonja, 36',
  text: 'Ich bin Yogalehrerin und achte auf alles – Ernährung, Bewegung, Meditation. Aber mein Kissen habe ich komplett vernachlässigt. Danke für den Denkanstoß!',
  likes: 15,
  likedByUser: false,
  timestamp: Date.now() - 32 * DAY
}, {
  id: 's-38',
  name: 'Margit, 51',
  text: 'Meine Kollegin hat mir von ihrem neuen Kissen vorgeschwärmt. Ich dachte, sie übertreibt. Jetzt habe ich selbst eins und verstehe sie komplett.',
  likes: 11,
  likedByUser: false,
  timestamp: Date.now() - 35 * DAY
}, {
  id: 's-39',
  name: 'Carolin, 29',
  text: 'Der Punkt mit der weiblichen Anatomie hat mich echt überrascht. Warum werden Kissen nicht standardmäßig für verschiedene Körpertypen angeboten?',
  likes: 25,
  likedByUser: false,
  timestamp: Date.now() - 38 * DAY
}, {
  id: 's-40',
  name: 'Ingrid, 67',
  text: 'Ich lese selten Online-Artikel zu Ende. Diesen hier schon. Sehr gut geschrieben und endlich mal ein Thema, das wirklich wichtig ist.',
  likes: 20,
  likedByUser: false,
  timestamp: Date.now() - 42 * DAY
}];
const VISIBLE_COUNT = 8;
function getTimeAgo(timestamp: number): string {
  const diff = Date.now() - timestamp;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  const weeks = Math.floor(diff / 604800000);
  if (minutes < 1) return 'gerade eben';
  if (minutes < 60) return `vor ${minutes} Min.`;
  if (hours < 24) return `vor ${hours} Std.`;
  if (days < 7) return `vor ${days} ${days === 1 ? 'Tag' : 'Tagen'}`;
  return `vor ${weeks} ${weeks === 1 ? 'Woche' : 'Wochen'}`;
}
function getInitial(name: string): string {
  return name.charAt(0).toUpperCase();
}
const AVATAR_COLORS = [{
  bg: 'bg-vita-green-sage/30',
  text: 'text-vita-green-deep'
}, {
  bg: 'bg-[#D4A853]/20',
  text: 'text-[#D4A853]'
}, {
  bg: 'bg-[#8B7BAF]/20',
  text: 'text-[#8B7BAF]'
}, {
  bg: 'bg-[#E8A0BF]/20',
  text: 'text-[#C06090]'
}, {
  bg: 'bg-[#7BAFD4]/20',
  text: 'text-[#4A8AB0]'
}];
function getAvatarColor(id: string) {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
export function CommentsSection({
  articleSlug
}: {
  articleSlug: string;
}) {
  const storageKey = `vitafrukt-comments-${articleSlug}`;
  const [comments, setComments] = useState<Comment[]>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) return JSON.parse(stored);
    } catch {}
    return INITIAL_COMMENTS;
  });
  const [name, setName] = useState('');
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(comments));
    } catch {}
  }, [comments, storageKey]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !text.trim()) return;
    setIsSubmitting(true);
    setTimeout(() => {
      const newComment: Comment = {
        id: `comment-${Date.now()}`,
        name: name.trim(),
        text: text.trim(),
        likes: 0,
        likedByUser: false,
        timestamp: Date.now()
      };
      setComments(prev => [newComment, ...prev]);
      setName('');
      setText('');
      setIsSubmitting(false);
    }, 400);
  };
  const handleLike = (commentId: string) => {
    setComments(prev => prev.map(c => c.id === commentId ? {
      ...c,
      likes: c.likedByUser ? c.likes - 1 : c.likes + 1,
      likedByUser: !c.likedByUser
    } : c));
  };
  const visibleComments = showAll ? comments : comments.slice(0, VISIBLE_COUNT);
  const hiddenCount = comments.length - VISIBLE_COUNT;
  return <div className="mb-10" data-id="element-52">
      <h3 className="font-heading text-lg md:text-xl font-bold text-vita-text mb-6" data-id="element-53">
        💬 Kommentare ({comments.length})
      </h3>

      {/* Comment Form */}
      <form onSubmit={handleSubmit} className="mb-8" data-id="element-54">
        <div className="bg-[#F9F7F4] rounded-softer p-5 md:p-6 border border-[#EDE9E3]" data-id="element-55">
          <div className="flex items-center gap-3 mb-4" data-id="element-56">
            <div className="w-9 h-9 rounded-full bg-vita-green-sage/20 flex items-center justify-center flex-shrink-0" data-id="element-57">
              <UserIcon className="w-4 h-4 text-vita-green-deep" data-id="element-58" />
            </div>
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Dein Name" className="flex-1 bg-white border border-[#E0DCD6] rounded-full px-4 py-2 text-sm text-vita-text placeholder:text-vita-text-light focus:outline-none focus:border-vita-green-sage focus:ring-1 focus:ring-vita-green-sage/30 transition-colors" maxLength={50} data-id="element-59" />
          </div>
          <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Schreibe einen Kommentar…" rows={3} className="w-full bg-white border border-[#E0DCD6] rounded-2xl px-4 py-3 text-sm text-vita-text placeholder:text-vita-text-light focus:outline-none focus:border-vita-green-sage focus:ring-1 focus:ring-vita-green-sage/30 transition-colors resize-none leading-relaxed" maxLength={500} data-id="element-60" />
          <div className="flex items-center justify-between mt-3" data-id="element-61">
            <span className="text-xs text-vita-text-light" data-id="element-62">
              {text.length}/500
            </span>
            <button type="submit" disabled={!name.trim() || !text.trim() || isSubmitting} className="inline-flex items-center gap-2 px-5 py-2 bg-vita-green-deep text-white text-sm font-medium rounded-full hover:bg-vita-green-medium transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed active:scale-[0.97]" data-id="element-63">
              {isSubmitting ? <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-64" /> : <SendIcon className="w-3.5 h-3.5" data-id="element-65" />}
              Absenden
            </button>
          </div>
        </div>
      </form>

      {/* Comments List */}
      <div className="space-y-4" data-id="element-66">
        <AnimatePresence mode="popLayout" data-id="element-67">
          {visibleComments.map(comment => {
          const color = getAvatarColor(comment.id);
          return <motion.div key={comment.id} layout initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -12
          }} transition={{
            duration: 0.3
          }} className="bg-[#F9F7F4] rounded-softer p-5 md:p-6 border border-[#EDE9E3]" data-id="element-68">
                <p className="text-vita-text leading-relaxed text-base md:text-lg mb-4" data-id="element-69">
                  {comment.text}
                </p>
                <div className="flex items-center justify-between" data-id="element-70">
                  <div className="flex items-center gap-2" data-id="element-71">
                    <span className={`w-8 h-8 rounded-full ${color.bg} flex items-center justify-center text-sm font-semibold ${color.text}`} data-id="element-72">
                      {getInitial(comment.name)}
                    </span>
                    <div data-id="element-73">
                      <p className="text-sm font-medium text-vita-text" data-id="element-74">
                        {comment.name}
                      </p>
                      <p className="text-xs text-vita-text-light" data-id="element-75">
                        {getTimeAgo(comment.timestamp)}
                      </p>
                    </div>
                  </div>
                  <button onClick={() => handleLike(comment.id)} className="group flex items-center gap-1.5 transition-all duration-200" aria-label={comment.likedByUser ? 'Gefällt mir entfernen' : 'Gefällt mir'} data-id="element-76">
                    <HeartIcon className={`w-[18px] h-[18px] transition-all duration-200 ${comment.likedByUser ? 'fill-red-400 text-red-400 scale-110' : 'text-vita-text-light group-hover:text-red-400'}`} data-id="element-77" />
                    <span className={`text-sm tabular-nums transition-colors duration-200 ${comment.likedByUser ? 'text-red-400 font-medium' : 'text-vita-text-light group-hover:text-red-400'}`} data-id="element-78">
                      {comment.likes}
                    </span>
                  </button>
                </div>
              </motion.div>;
        })}
        </AnimatePresence>
      </div>

      {/* Show More / Show Less */}
      {comments.length > VISIBLE_COUNT && <div className="mt-6 text-center" data-id="element-79">
          <button onClick={() => setShowAll(prev => !prev)} className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-vita-green-deep bg-vita-green-sage/10 rounded-full hover:bg-vita-green-sage/20 transition-colors duration-200 active:scale-[0.97]" data-id="element-80">
            {showAll ? <>Weniger anzeigen</> : <>
                {hiddenCount} weitere Kommentare anzeigen
                <ChevronDownIcon className="w-4 h-4" data-id="element-81" />
              </>}
          </button>
        </div>}
    </div>;
}